/* global axios */
import ApiClient from './ApiClient';

class BankSettingsAPI extends ApiClient {
  constructor() {
    super('bank_settings', { accountScoped: true });
  }

  // Gera o token do banco agora (manual)
  refreshToken(id) {
    return axios.post(`${this.url}/${id}/refresh_token`);
  }
}

// Chaves de API que os sistemas externos usam pra ler o token
class BankApiKeysClient extends ApiClient {
  constructor() {
    super('bank_api_keys', { accountScoped: true });
  }
}

export const BankApiKeysAPI = new BankApiKeysClient();
export default new BankSettingsAPI();
